/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * AverageIcon
 */
export default class AverageIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M3.05 1c.541 0 .987.42 1.044.96l.006.117v17.77h17.85c.58 0 1.05.481 1.05 1.076 0 .555-.41 1.012-.936 1.07L21.95 22H3.05a1.06 1.06 0 01-1.044-.96L2 20.923V2.077C2 1.482 2.47 1 3.05 1zm6.936 10.164C9.453 14.367 7.76 17 6 17a1 1 0 010-2c.454 0 1.622-1.817 2.014-4.164C8.672 6.886 10.2 4 13 4s4.328 2.885 4.986 6.836C18.378 13.183 19.546 15 20 15a1 1 0 010 2c-1.76 0-3.453-2.633-3.986-5.836C15.51 8.141 14.376 6 13 6s-2.51 2.14-3.014 5.164z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

